<template>
    <div class="flex flex-col">
        <div>
            <h1 class="text-2xl font-semibold text-gray-900">
                {{ $t('dashboard.name') }}
            </h1>
        </div>

        <div>
            <licenses-overview
                :license-data="androidData"
                :title="$t(Platform.ANDROID.path)"
                v-if="androidData.length"
            />
            <licenses-overview
                :license-data="pcData"
                :title="$t(Platform.PC.path)"
                v-if="pcData.length"
            />
            <licenses-overview
                :license-data="oemData"
                :title="$t(Platform.OEM.path)"
                v-if="oemData.length"
            />

            <!--            <div class="flex w-full mt-8">-->
            <!--                <div class="w-full flex-col pr-4">-->
            <!--                    <h3 class="text-xl font-semibold text-gray-900">-->
            <!--                        {{ $t('orders.history') }}-->
            <!--                    </h3>-->

            <!--                    <div class="bg-white shadow overflow-hidden sm:rounded-md">-->
            <!--                        <ul>-->
            <!--                            <li>-->
            <!--                                <a class="block hover:bg-gray-50 focus:outline-none focus:bg-gray-50 transition duration-150 ease-in-out" href="#">-->
            <!--                                    <div class="px-4 py-4 sm:px-6">-->
            <!--                                        <div class="flex items-center justify-between">-->
            <!--                                            <div class="text-sm leading-5 font-medium text-indigo-600 truncate">-->
            <!--                                                Order #00231-->
            <!--                                            </div>-->
            <!--                                            <div class="ml-2 flex-shrink-0 flex">-->
            <!--                                                <span class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-yellow-100 text-yellow-800">-->
            <!--                                                    Pending validation-->
            <!--                                                </span>-->
            <!--                                            </div>-->
            <!--                                        </div>-->

            <!--                                        <div class="mt-2 sm:flex sm:justify-between">-->
            <!--                                            <div class="sm:flex">-->
            <!--                                                <div class="mr-6 flex items-center text-sm leading-5 text-gray-500">-->
            <!--                                                    5 Observers-->
            <!--                                                </div>-->

            <!--                                                <div class="mt-2 flex items-center text-sm leading-5 text-gray-500 sm:mt-0">-->
            <!--                                                    45 Complete-->
            <!--                                                </div>-->
            <!--                                            </div>-->

            <!--                                            <div class="mt-2 flex items-center text-sm leading-5 text-gray-500 sm:mt-0">-->
            <!--                                                Ordered on July 1st, 2020-->
            <!--                                            </div>-->
            <!--                                        </div>-->
            <!--                                    </div>-->
            <!--                                </a>-->
            <!--                            </li>-->

            <!--                            <li>-->
            <!--                                <a class="block hover:bg-gray-50 focus:outline-none focus:bg-gray-50 transition duration-150 ease-in-out" href="#">-->
            <!--                                    <div class="px-4 py-4 sm:px-6">-->
            <!--                                        <div class="flex items-center justify-between">-->
            <!--                                            <div class="text-sm leading-5 font-medium text-indigo-600 truncate">-->
            <!--                                                Order #000110-->
            <!--                                            </div>-->
            <!--                                            <div class="ml-2 flex-shrink-0 flex">-->
            <!--                                                <span class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800">-->
            <!--                                                    Paid-->
            <!--                                                </span>-->
            <!--                                            </div>-->
            <!--                                        </div>-->

            <!--                                        <div class="mt-2 sm:flex sm:justify-between">-->
            <!--                                            <div class="sm:flex">-->
            <!--                                                <div class="mr-6 flex items-center text-sm leading-5 text-gray-500">-->
            <!--                                                    100 Super version-->
            <!--                                                </div>-->

            <!--                                                <div class="mr-6 mt-2 flex items-center text-sm leading-5 text-gray-500 sm:mt-0">-->
            <!--                                                    45 Complete-->
            <!--                                                </div>-->

            <!--                                                <div class="mt-2 flex items-center text-sm leading-5 text-gray-500 sm:mt-0">-->
            <!--                                                    6 Duper-->
            <!--                                                </div>-->
            <!--                                            </div>-->

            <!--                                            <div class="mt-2 flex items-center text-sm leading-5 text-gray-500 sm:mt-0">-->
            <!--                                                Ordered on January 7, 2020-->
            <!--                                            </div>-->
            <!--                                        </div>-->
            <!--                                    </div>-->
            <!--                                </a>-->
            <!--                            </li>-->

            <!--                            <li class="border-t border-gray-200">-->
            <!--                                <a class="block hover:bg-gray-50 focus:outline-none focus:bg-gray-50 transition duration-150 ease-in-out" href="#">-->
            <!--                                    <div class="px-4 py-4 sm:px-6">-->
            <!--                                        <div class="flex items-center justify-between">-->
            <!--                                            <div class="text-sm leading-5 font-medium text-indigo-600 truncate">-->
            <!--                                                Back End Developer-->
            <!--                                            </div>-->
            <!--                                            <div class="ml-2 flex-shrink-0 flex">-->
            <!--                                                <span class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800">-->
            <!--                                                    Full-time-->
            <!--                                                </span>-->
            <!--                                            </div>-->
            <!--                                        </div>-->
            <!--                                        <div class="mt-2 sm:flex sm:justify-between">-->
            <!--                                            <div class="sm:flex">-->
            <!--                                                <div class="mr-6 flex items-center text-sm leading-5 text-gray-500">-->
            <!--                                                    <svg class="flex-shrink-0 mr-1.5 h-5 w-5 text-gray-400" fill="currentColor" viewBox="0 0 20 20">-->
            <!--                                                        <path d="M9 6a3 3 0 11-6 0 3 3 0 016 0zM17 6a3 3 0 11-6 0 3 3 0 016 0zM12.93 17c.046-.327.07-.66.07-1a6.97 6.97 0 00-1.5-4.33A5 5 0 0119 16v1h-6.07zM6 11a5 5 0 015 5v1H1v-1a5 5 0 015-5z" />-->
            <!--                                                    </svg>-->
            <!--                                                    Engineering-->
            <!--                                                </div>-->
            <!--                                                <div class="mt-2 flex items-center text-sm leading-5 text-gray-500 sm:mt-0">-->
            <!--                                                    <svg class="flex-shrink-0 mr-1.5 h-5 w-5 text-gray-400" fill="currentColor" viewBox="0 0 20 20">-->
            <!--                                                        <path clip-rule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" fill-rule="evenodd" />-->
            <!--                                                    </svg>-->
            <!--                                                    Remote-->
            <!--                                                </div>-->
            <!--                                            </div>-->
            <!--                                            <div class="mt-2 flex items-center text-sm leading-5 text-gray-500 sm:mt-0">-->
            <!--                                                <svg class="flex-shrink-0 mr-1.5 h-5 w-5 text-gray-400" fill="currentColor" viewBox="0 0 20 20">-->
            <!--                                                    <path clip-rule="evenodd" d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z" fill-rule="evenodd" />-->
            <!--                                                </svg>-->
            <!--                                                <span>-->
            <!--                                                    Closing on-->
            <!--                                                    <time datetime="2020-01-07">January 7, 2020</time>-->
            <!--                                                </span>-->
            <!--                                            </div>-->
            <!--                                        </div>-->
            <!--                                    </div>-->
            <!--                                </a>-->
            <!--                            </li>-->
            <!--                        </ul>-->
            <!--                    </div>-->
            <!--                </div>-->

            <!--                <div class="w-full flex-col pl-4">-->
            <!--                    <h3 class="text-xl font-semibold text-gray-900">-->
            <!--                        {{ $t('activations.history') }}-->
            <!--                    </h3>-->

            <!--                    <div class="flex flex-col">-->
            <!--                        <div class="-my-2 py-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8">-->
            <!--                            <div class="align-middle inline-block min-w-full shadow overflow-hidden sm:rounded-lg border-b border-gray-200">-->
            <!--                                <table class="min-w-full">-->
            <!--                                    <thead>-->
            <!--                                        <tr>-->
            <!--                                            <th class="px-6 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">-->
            <!--                                                Type-->
            <!--                                            </th>-->
            <!--                                            <th class="px-6 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">-->
            <!--                                                Date-->
            <!--                                            </th>-->
            <!--                                        </tr>-->
            <!--                                    </thead>-->
            <!--                                    <tbody>-->
            <!--                                        <tr class="bg-white">-->
            <!--                                            <td class="px-6 py-4 whitespace-no-wrap text-sm leading-5 font-medium text-gray-900">-->
            <!--                                                Observer-->
            <!--                                            </td>-->
            <!--                                            <td class="px-6 py-4 whitespace-no-wrap text-sm leading-5 text-gray-500">-->
            <!--                                                2020-01-02 12:35:02-->
            <!--                                            </td>-->
            <!--                                        </tr>-->
            <!--                                        <tr class="bg-white">-->
            <!--                                            <td class="px-6 py-4 whitespace-no-wrap text-sm leading-5 font-medium text-gray-900">-->
            <!--                                                Observer-->
            <!--                                            </td>-->
            <!--                                            <td class="px-6 py-4 whitespace-no-wrap text-sm leading-5 text-gray-500">-->
            <!--                                                2020-01-02 12:35:02-->
            <!--                                            </td>-->
            <!--                                        </tr>-->
            <!--                                        <tr class="bg-white">-->
            <!--                                            <td class="px-6 py-4 whitespace-no-wrap text-sm leading-5 font-medium text-gray-900">-->
            <!--                                                Observer-->
            <!--                                            </td>-->
            <!--                                            <td class="px-6 py-4 whitespace-no-wrap text-sm leading-5 text-gray-500">-->
            <!--                                                2020-01-02 12:35:02-->
            <!--                                            </td>-->
            <!--                                        </tr>-->
            <!--                                        <tr class="bg-white">-->
            <!--                                            <td class="px-6 py-4 whitespace-no-wrap text-sm leading-5 font-medium text-gray-900">-->
            <!--                                                Observer-->
            <!--                                            </td>-->
            <!--                                            <td class="px-6 py-4 whitespace-no-wrap text-sm leading-5 text-gray-500">-->
            <!--                                                2020-01-02 12:35:02-->
            <!--                                            </td>-->
            <!--                                        </tr>-->
            <!--                                        <tr class="bg-white">-->
            <!--                                            <td class="px-6 py-4 whitespace-no-wrap text-sm leading-5 font-medium text-gray-900">-->
            <!--                                                Observer-->
            <!--                                            </td>-->
            <!--                                            <td class="px-6 py-4 whitespace-no-wrap text-sm leading-5 text-gray-500">-->
            <!--                                                2020-01-02 12:35:02-->
            <!--                                            </td>-->
            <!--                                        </tr>-->
            <!--                                    </tbody>-->
            <!--                                </table>-->
            <!--                            </div>-->
            <!--                        </div>-->
            <!--                    </div>-->
            <!--                </div>-->
            <!--            </div>-->
        </div>
    </div>
</template>

<script>
    import { mapState } from 'vuex';
    import Platform from '@/models/Platform.js';
    import LicensesOverview from '../components/Dashboard/LicensesOverview.vue';

    export default {
        components: { LicensesOverview },

        data() {
            return {
                Platform,
            };
        },

        computed: {
            ...mapState([
                'orders',
                'licenseTypes',
            ]),
            androidData() {
                const androidLicenses = [];
                for (let i = 0; i < this.licenseTypes.length; i++) {
                    if (this.licenseTypes[i].platform === 'android') {
                        androidLicenses.push({
                            id: this.licenseTypes[i].id,
                            registeredQuantity: 0,
                            unregisteredQuantity: 0,
                            quantity: 0,
                            name: this.licenseTypes[i].localized_name[this.$i18n.locale] ? this.licenseTypes[i].localized_name[this.$i18n.locale] : this.licenseTypes[i].name,
                        });
                    }
                }
                for (let i = 0; i < this.orders.length; i++) {
                    if (this.orders[i].status !== 'pending') {
                        for (let j = 0; j < this.orders[i].licenses.length; j++) {
                            const license = this.orders[i].licenses[j];
                            for (let k = 0; k < androidLicenses.length; k++) {
                                if (license.license_type_id === androidLicenses[k].id) {
                                    if (license.activation_date === null) androidLicenses[k].unregisteredQuantity++;
                                    else androidLicenses[k].registeredQuantity++;
                                }
                            }
                        }
                    }
                    for (let j = 0; j < this.orders[i].items.length; j++) {
                        const item = this.orders[i].items[j];
                        for (let k = 0; k < androidLicenses.length; k++) {
                            if (item.license_type_id === androidLicenses[k].id) {
                                androidLicenses[k].quantity += item.quantity;
                            }
                        }
                    }
                }
                return androidLicenses;
            },
            pcData() {
                const pcLicenses = [];
                for (let i = 0; i < this.licenseTypes.length; i++) {
                    if (this.licenseTypes[i].platform === 'pc') {
                        pcLicenses.push({
                            id: this.licenseTypes[i].id,
                            registeredQuantity: 0,
                            unregisteredQuantity: 0,
                            quantity: 0,
                            name: this.licenseTypes[i].localized_name[this.$i18n.locale] ? this.licenseTypes[i].localized_name[this.$i18n.locale] : this.licenseTypes[i].name,
                        });
                    }
                }
                for (let i = 0; i < this.orders.length; i++) {
                    if (this.orders[i].status !== 'pending') {
                        for (let j = 0; j < this.orders[i].licenses.length; j++) {
                            const license = this.orders[i].licenses[j];
                            for (let k = 0; k < pcLicenses.length; k++) {
                                if (license.license_type_id === pcLicenses[k].id) {
                                    if (license.activation_date === null) pcLicenses[k].unregisteredQuantity++;
                                    else pcLicenses[k].registeredQuantity++;
                                }
                            }
                        }
                    }
                    for (let j = 0; j < this.orders[i].items.length; j++) {
                        const item = this.orders[i].items[j];
                        for (let k = 0; k < pcLicenses.length; k++) {
                            if (item.license_type_id === pcLicenses[k].id) {
                                pcLicenses[k].quantity += item.quantity;
                            }
                        }
                    }
                }
                return pcLicenses;
            },
            oemData() {
                const oemLicenses = [];
                for (let i = 0; i < this.licenseTypes.length; i++) {
                    if (this.licenseTypes[i].platform === 'oem') {
                        oemLicenses.push({
                            id: this.licenseTypes[i].id,
                            registeredQuantity: 0,
                            unregisteredQuantity: 0,
                            quantity: 0,
                            name: this.licenseTypes[i].localized_name[this.$i18n.locale] ? this.licenseTypes[i].localized_name[this.$i18n.locale] : this.licenseTypes[i].name,
                        });
                    }
                }
                for (let i = 0; i < this.orders.length; i++) {
                    if (this.orders[i].status !== 'pending') {
                        for (let j = 0; j < this.orders[i].licenses.length; j++) {
                            const license = this.orders[i].licenses[j];
                            for (let k = 0; k < oemLicenses.length; k++) {
                                if (license.license_type_id === oemLicenses[k].id) {
                                    if (license.activation_date === null) oemLicenses[k].unregisteredQuantity++;
                                    else oemLicenses[k].registeredQuantity++;
                                }
                            }
                        }
                    }
                    for (let j = 0; j < this.orders[i].items.length; j++) {
                        const item = this.orders[i].items[j];
                        for (let k = 0; k < oemLicenses.length; k++) {
                            if (item.license_type_id === oemLicenses[k].id) {
                                oemLicenses[k].quantity += item.quantity;
                            }
                        }
                    }
                }
                return oemLicenses;
            },
        },
    };
</script>
